<template>
  <div>
  </div>
</template>

<script>
// import VueFrame from 'vue-frame'
export default {
  name: 'LandingPage',
  components: {
    // VueFrame
  },
  data() {
    return {
      links: {
        collab: ""
      },
      accessToken: ""
    }
  },
}
</script>

<style scoped>

</style>
